import { UiModel } from "@durlabh/dframework-ui";

class CommonUiModel extends UiModel {
  static defaultColumnConfig = {
    width: 200,
    type: "string"
  };
  static multilineColumnConfig = {
    width: 350,
    type: "string",
    rows: 5,
    variant: "outlined",
    max: 2000
  };
  static defaultConfig = {
    showBreadcrumbs: true
  };
  constructor(config) {
    const { columns } = config;
    // setting default sort is null or undefined
    // to remove the default sort pass defaultSort: ""
    config.defaultSort = config.defaultSort ?? "ModifiedOn desc";
    config.showHeaderFilters = false;
    config.columns = columns.map((column) => {
      const isMultiline = column.multiline;
      const addlConfig = isMultiline ? CommonUiModel.multilineColumnConfig : {};
      column = {
        ...CommonUiModel.defaultColumnConfig,
        ...addlConfig,
        label: column.field,
        ...column
      };
      if (column.type === "number") {
        column.minValue = column.minValue || 0;
      }
      return column;
    });
    super(config);
  }
}
export default CommonUiModel;